<span *ngIf="errorMessage !== null">{{errorMessage}}</span>
